import * as yup from 'yup'
import { i18WithDefault as t } from '@shared/locale'
import { Types } from 'service-api'
import {
  isCheckInTimeEnabled,
  isCheckInTimeRequired,
  isCheckOutTimeEnabled,
  isCheckOutTimeRequired,
  isVetEnabled,
  isVetRequired,
} from 'components-ui/src/shared'
import { TBookingCart } from '@providers/booking/types'
import { profileSchemaTemplate } from '@components/profile_form/schema'

export const detailsPoliciesSchema = (
  reservation: Types.BookingReservationClientDto,
  inputCardGroups: Types.FlexBookingConfClientDto[][]
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const schema: any = {
    ...profileSchemaTemplate,
    careDetails: yup.string().max(200).label(t('specialInstructions.careDetails')),
  }

  if (isVetEnabled(reservation.locationBookingConf!)) {
    schema.vetName = yup.string().max(200).label(t('veterinarianInfoForm.vetName'))
    schema.vetPhone = yup.string().length(10).label(t('veterinarianInfoForm.vetPhone'))
    if (isVetRequired(reservation.locationBookingConf!)) {
      schema.vetName = schema.vetName.required()
      schema.vetPhone = schema.vetPhone.required()
    } else {
      schema.vetName = schema.vetName.when('vetPhone', {
        is: (phone: string) => !!phone,
        then: (field: yup.StringSchema) => field.required(),
        otherwise: (field: yup.StringSchema) => field.optional(),
      })
      schema.vetPhone = schema.vetPhone.when('vetName', {
        is: (name: string) => !!name,
        then: (field: yup.StringSchema) => field.required(),
        otherwise: (field: yup.StringSchema) => field.optional(),
      })
    }
  }

  if (isCheckInTimeEnabled(reservation.locationBookingConf!)) {
    schema.checkInTime = yup.string().label(t('checkInOutForm.checkIn'))
    if (isCheckInTimeRequired(reservation.locationBookingConf!)) {
      schema.checkInTime = schema.checkInTime.required()
    }
  }
  if (isCheckOutTimeEnabled(reservation.locationBookingConf!)) {
    schema.checkOutTime = yup.string().label(t('checkInOutForm.checkOut'))

    if (isCheckOutTimeRequired(reservation.locationBookingConf!)) {
      schema.checkOutTime = schema.checkOutTime.required()
    }
  }

  inputCardGroups.forEach((groups) => {
    groups.forEach((field) => {
      const fieldName = field.name!
      schema[fieldName] = yup.string()
      if (field.fieldRequired) {
        schema[fieldName] = schema[fieldName].required(t('detailsPolicies.requiredField'))
      }
    })
  })

  return yup.object().shape(schema, [['vetName', 'vetPhone']])
}

export const setupInitialValues = (cart: TBookingCart) => {
  return {
    // contact information
    firstName: cart.contact.firstName,
    lastName: cart.contact.lastName,
    email: cart.contact.email,
    phone: cart.contact.phone,
    smsConsentStatus: cart.contact.smsConsentStatus,
    streetAddress: cart.contact.mailingAddress.streetAddress,
    streetAddress2: cart.contact.mailingAddress.streetAddress2 || '',
    city: cart.contact.mailingAddress.city,
    state: cart.contact.mailingAddress.state,
    zipCode: cart.contact.mailingAddress.zipCode,
    country: cart.contact.mailingAddress.country,
    // checkIn - checkOut
    checkInTime: cart?.checkInTime || '',
    checkOutTime: cart?.checkOutTime || '',
    // veterinarian
    vetName: cart?.vet.name || '',
    vetPhone: cart?.vet.phone || '',
    // vaccination records
    // special instructions
    careDetails: '',
  }
}

export const getProfileValues = (formValues: Record<string, string>) => {
  return {
    firstName: formValues.firstName,
    lastName: formValues.lastName,
    // email: formValues.email,
    phone: formValues.phone,
    smsConsentStatus: formValues.smsConsentStatus,
    streetAddress: formValues.streetAddress,
    streetAddress2: formValues.streetAddress2 || null,
    city: formValues.city,
    state: formValues.state,
    zipCode: formValues.zipCode,
    // country: formValues.country,
  }
}
